import { GameElementType } from './enums';
/**
 * Maps element types to single-letter identifiers
 */
export const TYPE_IDENTIFIERS = {
    [GameElementType.TURN]: 'T',
    [GameElementType.PROMPT]: 'P',
    [GameElementType.ANSWER]: 'A',
    [GameElementType.VOTE]: 'V',
    INFO: 'I',
    SCORE: 'S',
    MEDIA: 'M',
    WINDOW: 'W',
    TEAM: 'E', // Using 'E' for tEam to avoid conflict with T for Turn
};
//# sourceMappingURL=id.js.map